export default __webpack_public_path__ + "images/md-content-copy-hover.svg";